import { getUserAccessPoliciesLocal } from '@chr/online-shared-microsite-core';
import { PermissionIds, EntityType } from '@chr/online-shared-ui-constants';
import { AccessPolicy } from '@chr/online-shared-microsite-core/types';



export const checkAnyPermission = (permissions: PermissionIds[]) => {
  const accessPolicies = getUserAccessPoliciesLocal();
  for (const permission of permissions) {
    if (accessPolicies && checkPermission(accessPolicies, permission)) {
      return true;
    }
  }
  return false;
};

const checkPermission = (accessPolicies: AccessPolicy[], permissionId: PermissionIds) => {
    const customerPolicies = accessPolicies?.filter((p: any) => p.entity?.entityTypeID === EntityType.CUSTOMER);
    return customerPolicies?.some(obj => obj.permissionIds?.includes(permissionId));
};